module.exports = __webpack_public_path__ + "static/saul-b181df1c33d9fa8dac362b58eec3eeac.png";